<template>
 <section>
    <LoadingSpinner v-if="oliverSalesLoaded" />
    <div v-else class="row">
      <div class="col-12">
        <span class="p-0 mt-1 h4 text-secondary">Ranking</span>
        <span class="p-0 ml-3">
          <select v-model="monthSelected" class="form-control ml-1" @change="init()">
            <option v-for ="(month, index) in months" :key="index" :value="month.id">
              {{ month.name }}
            </option>
          </select>
        </span>
      </div>
      <div class="col-12">
        <div class="row px-4">

          <!-- Sale:  First position  -->
          <div class="col-12 col-lg-4">
            <div class="row px-2 text-center" v-if="dataRankingReady">
              <div class="col-12 py-5">
                <div class="position-relative d-inline-block">
                  <img v-if="firstSale.avatar" :src="firstSale.avatar" class="rounded-circle border-color img-user"  width="233px" height="233px">
                  <img  v-else src="@/assets/images/user.png" class="rounded-circle border-color img-user"  width="233px" height="233px">
                  <img :src="logo_ranking(0)" class="rounded-circle border-color img-user position-absolute overlay-logo"  width="105px" height="105px">
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-12 h4 text-primary">
                    <p class="font-weight-bold">{{firstSale.name}} {{firstSale.lastname}}</p>
                    <p class="display-3 text-dark font-weight-bold my-2">#1</p>
                    <!-- <p class="h4 text-dark">2d 12h 23m 14s</p> -->
                    <p class="h4 text-dark font-weight-bold">{{ firstSale.score }} pts</p>
                  </div>
                  <div class="col-12">
                    <small></small>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th scope="col">
                      </th>
                      <th scope="col">
                      </th>
                      <!-- <th scope="col">
                        <small>Active clients</small>
                      </th> -->
                      <th scope="col">
                        <smalL>Active orders</small>
                      </th>
                      <th scope="col">
                       <small>Points</small>
                       <Tooltip
                          text="(Revenue/campaign * Campaign performance) + (new orders (old clients) * 3%) + (new orders (new clients)  *3%)"
                          :width="''"
                        >
                          <div
                            class="ml-3 mt-3 circle bg-secondary d-flex align-items-center justify-content-center"
                          >
                            <div class="question-mark text-white">?</div>
                          </div>
                        </Tooltip>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(oliverSale, index) in oliverSales" :key="oliverSale.id">
                      <td class="text-left px-0 mx-0">
                        <span v-if="(index < 3)">
                          <img :src="logo_ranking(index)" class="rounded-circle border-color img-user"  width="25px" height="25px">
                        </span>
                      </td>
                      <td class="text-left">
                        <img v-if="oliverSale.avatar" :src="oliverSale.avatar" class="rounded-circle border-color img-user"  width="25px" height="25px">
                        <img  v-else src="@/assets/images/user.png" class="rounded-circle border-color img-user"  width="25px" height="25px">
                        <span class="ml-3">
                          {{oliverSale.name}} {{oliverSale.lastname}}
                        </span>
                      </td>
                      <!-- <td>
                        {{ oliverSale.total_clients }}
                      </td> -->
                      <td>
                        {{ oliverSale.total_target }}
                      </td>
                      <td>
                        {{ oliverSale.score }}
                      </td>
                    </tr>
                  </tbody>

                </table>
              </div>
            </div>

            <div class="row px-2 text-center" v-else>
              <div class="col-12 py-5">
                <img  src="@/assets/images/user.png" class="rounded-circle border-color img-user"  width="233px" height="233px">
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-4" style="overflow-x: hidden;">

            <!-- Order performance ranking -->
            <div class="row flex-grow-1 overflow-auto my-4 px-2">
              <div class="col-12">
                <h5 class="font-weight-bold">Campaign performance</h5>
                <small>
                  Average conversion rate for active orders in the current month
                </small>
              </div>
              <div class="col=12 w-100 my-2" style="height: 35vh; overflow-x: hidden;">
                <ul class="list-group p-0">
                  <li class="list-group-item p-1"
                    v-for="(oliverSale, index) in sortOliverSales('order_performances')" :key="index"
                  >
                    <div class="row px-1 pt-1" >
                      <div class="col-2 pt-1 text-center">
                        <img v-if="oliverSale.avatar" :src="oliverSale.avatar" class="rounded-circle border-color img-user"  width="38px" height="38px">
                        <img  v-else src="@/assets/images/user.png" class="rounded-circle border-color img-user"  width="38px" height="38px">
                      </div>
                      <div class="col-10 pl-1">
                        <div class="row">
                          <div class="col-12">
                            <div class="row">
                              <div class="col-8 font-weight-bold">
                                {{oliverSale.name}} {{oliverSale.lastname}}
                              </div>
                              <div class="col-4" v-if="loading.order_performaces">
                                <Loadingcircle :paramloading="paramloading"  />
                              </div>
                              <div class="col-4" v-else>
                                <span v-if="oliverSale.order_performances" class="ml-4 h6 text-primary font-weight-bold">
                                  {{oliverSale.order_performances}} %
                                </span>
                                <span v-else></span>
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <small v-if="dataRankingReady" class="font-italic">{{ oliverSale.score }} pts</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <!-- New orders (old clients) ranking -->
            <div class="row flex-grow-1 overflow-auto my-4 px-2">
              <div class="col-12 font-weight-bold">
                <h5 class="font-weight-bold">New orders (old clients)</h5>
                <small>
                  Total orders sold for old clients in the current month
                </small>
              </div>
              <div class="col=12 w-100 my-2" style="height: 35vh; overflow-x: hidden;">
                <ul class="list-group p-0 ">
                  <li class="list-group-item p-1 border border-top-1 border-bottom-1"
                    v-for="(oliverSale, index) in sortOliverSales('total_order')" :key="index"
                  >
                    <div class="row px-1 pt-1">
                      <div class="col-2 pt-1 text-center">
                        <img v-if="oliverSale.avatar" :src="oliverSale.avatar" class="rounded-circle border-color img-user"  width="38px" height="38px">
                        <img  v-else src="@/assets/images/user.png" class="rounded-circle border-color img-user"  width="38px" height="38px">
                      </div>
                      <div class="col-10 pl-1">
                        <div class="row">
                          <div class="col-12">
                            <div class="row">
                              <div class="col-9 font-weight-bold">
                                {{oliverSale.name}} {{oliverSale.lastname}}
                              </div>
                              <div class="col-3" v-if="loading.total_order">
                                <Loadingcircle :paramloading="paramloading"  />
                              </div>
                              <div class="col-3" v-else>
                                <span v-if="oliverSale.total_order" class="ml-4 h6 text-primary font-weight-bold">
                                  {{oliverSale.total_order}}
                                </span>
                                <span v-else></span>
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <small v-if="dataRankingReady" class="font-italic">{{ oliverSale.score }} pts</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-4">

            <!-- Profitability rankin -->
            <div class="row flex-grow-1 overflow-auto my-4 px-2">
              <div class="col-12">
                <h5 class="font-weight-bold">Revenue / Campaigns</h5>
                <small>
                  Value of active orders' collectable appointments this month.
                </small>
              </div>
              <div class="col=12 w-100 my-2" style="height: 35vh; overflow-x: hidden;">
                <ul class="list-group p-0">
                  <li class="list-group-item p-1"
                    v-for="(oliverSale, index) in sortOliverSales('revenue_orders')" :key="index"
                  >
                    <div class="row px-1 pt-1">
                      <div class="col-2 pt-1 text-center">
                        <img v-if="oliverSale.avatar" :src="oliverSale.avatar" class="rounded-circle border-color img-user"  width="38px" height="38px">
                        <img  v-else src="@/assets/images/user.png" class="rounded-circle border-color img-user"  width="38px" height="38px">
                      </div>
                      <div class="col-10  pl-1">
                        <div class="row">
                          <div class="col-12">
                            <div class="row">
                              <div class="col-7 font-weight-bold">
                                {{oliverSale.name}} {{oliverSale.lastname}}
                              </div>
                              <div class="col-5" v-if="loading.revenue_orders">
                                <span width="20px">
                                  <Loadingcircle :paramloading="paramloading"  />
                                </span>
                              </div>
                              <div class="col-5 text-center" v-else>
                                <span v-if="oliverSale.revenue_orders" class="ml-4 h6 text-primary font-weight-bold">
                                  € {{oliverSale.revenue_orders}}
                                </span>
                                <span v-else></span>
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <small v-if="dataRankingReady" class="font-italic">{{ oliverSale.score }} pts</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <!-- New order (new client) ranking -->
            <div class="row flex-grow-1 overflow-auto my-4 px-2">
              <div class="col-12">
                <h5 class="font-weight-bold">New order (new client)</h5>
                <small>
                  Total orders sold for old clients in the current month
                </small>
              </div>
              <div class="col=12 w-100 my-2" style="height: 35vh; overflow-x: hidden;">
                <ul class="list-group p-0">
                  <li class="list-group-item  p-1"
                    v-for="(oliverSale, index) in sortOliverSales('new_order_to_new_client')" :key="index"
                  >
                    <div class="row px-1 pt-1">
                      <div class="col-2 pt-1 text-center">
                        <img v-if="oliverSale.avatar" :src="oliverSale.avatar" class="rounded-circle border-color img-user"  width="38px" height="38px">
                        <img  v-else src="@/assets/images/user.png" class="rounded-circle border-color img-user"  width="38px" height="38px">
                      </div>
                      <div class="col-10  pl-1">
                        <div class="row">
                          <div class="col-12">
                            <div class="row">
                              <div class="col-9 font-weight-bold">
                                {{oliverSale.name}} {{oliverSale.lastname}}
                              </div>
                              <div class="col-9" v-if="loading.new_order_to_new_client">
                                <Loadingcircle :paramloading="paramloading"  />
                              </div>
                              <div class="col-3" v-else>
                                <span v-if="oliverSale.new_order_to_new_client" class="ml-4 h6 text-primary font-weight-bold">
                                  {{oliverSale.new_order_to_new_client}}
                                </span>
                                <span v-else></span>
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <small v-if="dataRankingReady" class="font-italic">{{ oliverSale.score }} pts</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
 </section>
</template>

<script>

import Loadingcircle from  "@/components/Common/Loadingcircle.vue";
import LoadingSpinner from '../LoadingSpinner.vue';
import Tooltip from "@/components/Common/Tooltip.vue";
import moment from "moment";
import { usersService } from "@/_services";

export default {
  name: 'OliverSales',
  components: { LoadingSpinner, Loadingcircle, Tooltip },

  created() {
    this.init()
  },
  data() {
    return {
      monthSelected: 0,
      currentMonth:  moment().month() + 1,
      months:[
        { id: "01", name: 'January' },
        { id: "02", name: 'February' },
        { id: "03", name: 'March' },
        { id: "04", name: 'April' },
        { id: "05", name: 'May' },
        { id: "06", name: 'June' },
        { id: "07", name: 'July' },
        { id: "08", name: 'August' },
        { id: "09", name: 'September' },
        { id: "10", name: 'October' },
        { id: "11", name: 'November' },
        { id: "12", name: 'December' },
      ],
      dataRankingReady: false,
      totalResponseData: 0,
      oliverSales: [],
      oliverSalesLoaded: true,
      paramloading: {
        width: '28px',
        height: '28px',
        color: '#5054EB'
      },
      loading: {
        'total_order': false,
        'new_order_to_new_client': false,
        'revenue_orders': false,
        'order_performances': false,
      },
      firstSale: {
        'name': '',
        'lastname': '',
        'avatar': ''
      }
    };
  },

  computed: {

    logo_ranking() {
      return (index) => {
        if(index == 0){
          return  require('@/assets/images/medal_1.png');
        }

        if(index == 1){
          return  require('@/assets/images/medal_2.png');
        }

        if(index == 2){
          return  require('@/assets/images/medal_3.png');
        }
        return ""
      }

    },

    sortOliverSales() {
      return (type) => {
        if (this.totalResponseData == 4 && this.dataRankingReady) {
          return [...this.oliverSales].sort((a, b) => {
            if (type === 'revenue_orders') return Number(b.revenue_orders) - Number(a.revenue_orders);
            if (type === 'new_order_to_new_client') return Number(b.new_order_to_new_client) - Number(a.new_order_to_new_client);
            if (type === 'total_order') return Number(b.total_order) - Number(a.total_order);
            if (type === 'order_performances') return parseFloat(b.order_performances) - parseFloat(a.order_performances);
            return 0;
          });
        } else {
          return this.oliverSales;
        }
      }
    }
  },

  watch: {
    totalResponseData(newVal, oldVal) {
      if(newVal == 4){
        this.calculateRanking()
      }
    }
  },

  methods: {

    init(){
      this.totalResponseData = 0
      if(this.monthSelected == 0){
        if(this.currentMonth > 9) {
          this.monthSelected = this.currentMonth.toString()
        } else {
          this.monthSelected = "0" +this.currentMonth.toString()
        }        
      }
      this.getUserOliverSales()    
      this.months = this.months.filter( el => el.id <= this.currentMonth)
    },

    getUserOliverSales(){
      this.oliverSalesLoaded = true
      usersService.getUserOliverSales('completeData', this.monthSelected)
      .then( res => {
        if(res.result.length > 0) {
          this.oliverSales = res.result;
          this.firstSale = res.result[0];

          const types = ["revenue_orders", "new_order_to_new_client", "total_order", "order_performaces"];
          const promises = types.map(type => this.getSaleStats(type));
          return Promise.all(promises);
        }
      })
      .then(() => {
        this.oliverSalesLoaded = false;
      })
      .catch( err => console.err(err))
    },

    getSaleStats(type){
      this.loading[type] = true

      return usersService.getSaleStats(type, this.monthSelected)
      .then( res => {
        if(res.result.length > 0) {
          const result = res.result

          if(type == 'revenue_orders'){
            this.oliverSales = this.oliverSales.map( item => {
              const resultItem = result.find(el => el.oliver_sale == item.id)
              return {...item, revenue_orders: (resultItem) ? resultItem.total : 0 }
            })
            this.loading[type] = false
            this.totalResponseData++
          }

          if(type == 'new_order_to_new_client'){
            this.oliverSales = this.oliverSales.map( item => {
              const resultItem = result.find(el => el.oliver_sale == item.id)
              return {...item, new_order_to_new_client: (resultItem) ? resultItem.total : 0 }
            })
            this.loading[type] = false
            this.totalResponseData++
          }

          if(type == 'total_order'){
            this.oliverSales = this.oliverSales.map( item => {
              const resultItem = result.find(el => el.oliver_sale == item.id)
              return {...item, total_order: (resultItem) ? resultItem.total : 0 }
            })
            this.loading[type] = false
            this.totalResponseData++
          }

          if(type == 'order_performaces'){
            this.oliverSales = this.oliverSales.map( item => {
              const resultItem = result.find(el => el.oliver_sale == item.id)
              return {...item, order_performances: (resultItem) ? resultItem.order_performaces : 0 }
            })
            this.loading[type] = false
            this.totalResponseData++
          }

        } else {
          if(type == 'new_order_to_new_client' || type == 'order_performaces' || type == 'total_order' || type == 'revenue_orders'){
            this.loading[type] = false
            this.totalResponseData++
          }
        }
      })
      .catch( err => console.error(err))
    },

    calculateRanking(){
      // Score: (Revenue/campaign * Campaign performance) + (new campaigns (old clients) * 3%) + (new orders (new clients)  *3%)

      this.oliverSales = this.oliverSales.map( item => {

      //const score = ((item.revenue_orders * item.order_performances) + (item.total_order * 0.03) + (item.new_order_to_new_client * 0.03))
      const new_order_to_new_client = item.new_order_to_new_client ? item.new_order_to_new_client * 0.03 : 0
      const total_order = item.total_order ? item.total_order * 0.03 : 0

      const revenue_orders = item.revenue_orders ? item.revenue_orders : 0
      const order_performances = item.order_performances ? item.order_performances : 0


      const score = ((revenue_orders * order_performances) + total_order + new_order_to_new_client ) // (item.new_order_to_new_client * 0.03)) // item.order_performances)) // + (item.total_order * 0.03) + (0 * 0.03))
      
        return {
          ...item,
          score: score.toFixed(2)
        }
      })

      //asigno a firstSale el usuario con mayor score
      this.firstSale = this.oliverSales.sort((a, b) => b.score - a.score)[0]

      this.dataRankingReady = true
      //this.oliverSalesLoaded = false
    },

  }
};
</script>
<style scoped>
  .row_scroll {
    height: 40vh;
    overflow-x: hidden !important;
  }

  .position-relative {
    position: relative;
  }

  .position-absolute {
    position: absolute;
  }

  .overlay-logo {
    bottom: -66px;
    left: 35px;
    transform: translate(-50%, -50%);
  }
</style>
